// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MeritBadgesTable-module__text___Pcl8R{word-break:keep-all}`, "",{"version":3,"sources":["webpack://./src/modules/meritBadgeCounselors/mbcDashboard/components/MeritBadgesTable.module.scss"],"names":[],"mappings":"AAAA,uCACE,mBAAA","sourcesContent":[".text {\n  word-break: keep-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `MeritBadgesTable-module__text___Pcl8R`
};
export default ___CSS_LOADER_EXPORT___;
